<template>
    <div>
        <div>
            <AlertDismiss class="mx-2 mt-2" ref="alertDismiss"></AlertDismiss>
        </div>  
        <div>
          <div class="m-2 overflow-hidden">
              <h5>Mantenedor de empresa</h5>
        
              <b-overlay :show="fetching">
                  <b-form  @submit.prevent="onSubmit">
                    <b-row no-gutters>
                        <div class="col-12 col-sm-4 mb-3">
                            <label for="nombreFormControlInput" class="form-label">Razón Social</label>
                            <div >
                                <input v-model="company.legalName" class="form-control" placeholder="Ingrese la razón social" id="nombreFormControlInput">
                            </div>
                        </div>
                
                        <div class="col-12 col-sm-4 mb-3">
                            <label for="giroFormControlInput" class="form-label">Giro</label>
                            <div >
                                <input v-model="company.coreBusiness" class="form-control" placeholder="Ingrese el giro" id="giroFormControlInput">
                            </div>
                        </div>

                        <div class="col-12 col-sm-4 mb-3">
                            <RutInput v-model="company.rut" id="RutFormControlInput"/>
                        </div>

                        <div class="col-12 col-sm-4 mb-3">
                            <label for="regionFormControlInput" class="form-label">Región</label>
                            <b-form-group>
                                <b-form-select
                                    class="form-control"
                                    id="regionFormControlInput"
                                    v-model="company.region"
                                    :options="regions"
                                >
                                <template #first>
                                    <option value="" disabled>-- Selecciona una región --</option>
                                </template>
                                </b-form-select>
                            </b-form-group>
                        </div>

                        <div class="col-12 col-sm-4 mb-3">
                            <b-form-group label="Provincia">
                                <b-form-select
                                    class="form-control"
                                    id="countyFormControlInput"
                                    v-model="company.county"
                                    :options="counties"
                                    :disabled="disableCounty"
                                >
                                <template #first>
                                    <option value="" disabled>-- Selecciona una Provincia --</option>
                                </template>
                                </b-form-select>
                                <div v-if="disableCounty" id="regionHelpBlock" class="form-text">
                                    Seleccione una región
                                </div>  
                            </b-form-group>
                        </div>

                        <div class="col-12 col-sm-4 mb-3">
                            <label for="munitipalityFormControlInput" class="form-label">Comuna</label>
                            <b-form-group>
                                <b-form-select
                                    class="form-control"
                                    id="munitipalityFormControlInput"
                                    v-model="company.idMunicipality"
                                    :options="munitipalities"
                                    :disabled="disableMunicipality"
                                >
                                <template #first>
                                    <option value="" disabled>-- Selecciona una Comuna --</option>
                                </template>
                                </b-form-select>
                                <div v-if="disableMunicipality" id="regionHelpBlock" class="form-text">
                                    Seleccione una provincia
                                </div>  
                            </b-form-group>
                        </div>

                        <div class="col-12 col-sm-4 mb-3">
                            <label for="ciudadFormControlInput" class="form-label">Ciudad</label>
                            <div >
                                <input v-model="company.city" class="form-control" placeholder="Ingrese la ciudad" id="ciudadFormControlInput">
                            </div>
                        </div>
                    
                        <div class="col-12 col-sm-4 mb-3">
                            <label for="direccionFormControlInput" class="form-label">Dirección</label>
                            <div >
                                <input v-model="company.direction" class="form-control" placeholder="Ingrese la dirección" id="direccionFormControlInput">
                            </div>
                        </div> 
                        <div class="col-12 col-sm-4 mb-3">
                            <label for="telefonosFormControlInput" class="form-label">Teléfonos</label>
                            <div>
                                <input v-model="company.phones" class="form-control" placeholder="Ingrese los teléfonos" id="telefonosFormControlInput">
                            </div>
                        </div>

                        <div class="col-12 col-sm-4 mb-3">
                            <label for="fechaSuscripcion">Fecha de suscripción</label>
                            <div>
                                <input type="date" v-model="company.subscriptionDate" class="form-control" id="fechaCreacionCompañia">
                            </div>
                        </div>
                  
                         <div class="col-12 col-sm-4 mb-3">
                            <label for="correoContacto">Correo de contacto</label>
                            <div>
                                <input type="email" v-model="company.contactEmail" class="form-control" placeholder="Ingrese el correo de contacto" id="correoContacto">
                            </div>  
                        </div>

                        <div class="col-12 col-sm-4 mb-3">
                            <label for="numeroCompaniasAdministradas">Número de compañias administradas</label>
                            <div>
                                <input type="number" v-model="company.maximumNumberOfPartners" class="form-control" placeholder="Ingrese número de compañias" id="numeroCompaniasAdministradas">
                            </div>  
                        </div>

                        <div class="col-12 col-sm-4 mb-3">
                          <b-form-group label="Escritura de la sociedad">
                            <b-form-file
                              v-model="company.legalDocument"
                              accept=".pdf"
                            />
                          </b-form-group>
                        </div>
                    </b-row>
                    <div class="row">
                      <div class="col-auto align-items-center d-flex">
                        <b-button
                            type="submit"
                            variant="outline-primary"
                            :disabled="isUploading"
                        >
                          <b-spinner small v-show="isUploading"></b-spinner>
                          Modificar empresa
                        </b-button>
                      </div>
                      <div class="col-auto flex-grow-1" v-show="showProgress">
                        <ProgressCustom ref="progressCustom"></ProgressCustom>
                      </div>
                    </div>
                    </b-form>
                </b-overlay>
            </div>
        </div>
    </div>
</template>
<script>

import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import { mapActions } from 'vuex';
import RutInput from '@/components/shared/RUT-input.vue';
import ProgressCustom from "@/components/shared/Progress-custom.vue";

const titleCase = (str) => str.charAt(0).toUpperCase() + str.slice(1)

export default {
    name: 'SettingCompany',

    components: {
        ProgressCustom,
        AlertDismiss,
        RutInput
    },

    data() {
        return {
            company: {
                legalName: '',
                coreBusiness: '',
                rut: '',
                region: '',
                county: '',
                idMunicipality: '',
                city: '',
                direction: '',
                phones: '',
                contactEmail: '',
                subscriptionDate: '',
                maximumNumberOfPartners: '',
                legalDocument: null
            },

            territories: {},

            documentId: '',
            process: false,
            fetching: true,
            isUploading: false,
            showProgress: false,
        }
    },

    computed: {
        regions() {
            return Object.keys(this.territories)
                .sort()
                .map(x => ({value: x, text: titleCase(x)}))
        },
        counties() {
            return Object.keys(this.territories[this.company.region] ?? {}).sort() 
        },
        munitipalities() {
            return this.territories[this.company.region]
                ?.[this.company.county]
                ?.slice()
                ?.sort((a, b) => a.text.localeCompare(b.text)) ?? []

        },
        disableCounty() {
            return this.company.region === ''
        },
        disableMunicipality() {
            return this.company.county === ''
        },
    },

    async mounted() {
        this.fetching = true
        await this.fetchTerritories()
        await this.fetchCompanyData()
        
        await this.initValueCompany(this.originalCompany)
        this.fetching = false
    },

    methods:{
        ...mapActions([
            "getAllTerritories", 
            "getCompany", 
            "updateCompany", 
            "saveCompanyInstanceDocument",
            "updateCompanyInstanceDocument", 
        ]),

        async initValueCompany(data) {
            const setField = ( field, value = data[field] ) => {
                const newValue = value.startsWith('sin dato') ? "" : value;
                this.company[field] = newValue;
            }
            setField('legalName');
            setField('coreBusiness');
            setField('rut');
            setField('city');
            setField('direction');
            setField('phones');
            setField('contactEmail', data.mail);
            if (!data.territory.region.startsWith('Default')) {
                setField('region', data.territory.region);
                setField('county', data.territory.county);
                setField('idMunicipality', data.territory.id);
            }
            setField('subscriptionDate', this.formatIsoDate(data.subscriptionDate))

            // we dont need to filter the default of the value
            this.company.maximumNumberOfPartners = data.maximumNumberOfPartners
        },

        async onSubmit() {
            this.isUploading = true;
            if (this.company.legalDocument !== null) {
                this.showProgress = true;
                await this.uploadDocument()
                await this.saveDocument()
            }
            await this.updateForm()

            this.isUploading = false;
        },

        async saveDocument() {
          if (this.documentId !== null) {
            let result = await this.saveCompanyInstanceDocument({
              route: this.documentId,
              name: this.company.legalDocument.name,
            })

            if (result.isError) {
              this.$refs.alertDismiss.showAlert(result.message, 'danger');
              this.$refs.progressCustom.progress(0);
              this.showProgress = false;
              this.isUploading = false;
              this.attemptedSubmit = true;
              return;
            }
          }
        },

        async updateForm() {
          this.$refs.progressCustom.progress(85, 'Actualizando información...');

          const data = {
            legalName: this.company.legalName,
            coreBusiness: this.company.coreBusiness,
            direction: this.company.direction,
            city: this.company.city,
            phones: this.company.phones,
            rut: this.company.rut,
            mail: this.company.contactEmail,
            subscriptionDate: this.toISODate(this.company.subscriptionDate),
            territoryId: this.company.idMunicipality,
            postalRegion: "Default",
            postalCode: "Default",
            maximumNumberOfPartners: this.company.maximumNumberOfPartners
          }

          let result = await this.updateCompany(data);

          if (result.isError) {
            this.$refs.alertDismiss.showAlert(result.message, 'danger');
            this.$refs.progressCustom.progress(0);
            this.showProgress = false;
            this.isUploading = false;
            this.attemptedSubmit = true;
            return;
          }

          this.$refs.progressCustom.progress(100, 'Proceso completado');
          this.$refs.alertDismiss.showAlert(
              'Datos actualizados correctamente',
              'success'
          );

          this.isUploading = false;
          this.company.legalDocument = null;
          this.documentId = null;

          setTimeout(() => {
            this.showProgress = false;
          }, 1000);
        },
        

    
      async uploadDocument() {
        if (this.documentId) {
          this.$refs.progressCustom.progress(100, 'Usando documento existente...');
          return;
        }

        this.$refs.progressCustom.progress(5, 'Cargando documento...');

        let result = await this.updateCompanyInstanceDocument(this.company.legalDocument);
        if (result.isError) {
          let msg = result.message
          if (msg.includes("Advertencia, la cantidad máxima de socios se mantiene en el árbol")) {
            msg = 'Número máximo de socios inferior al número de socios actuales'
          }
          this.$refs.alertDismiss.showAlert(msg, 'danger');
          this.$refs.progressCustom.progress(0 );
          return;
        }

        this.$refs.progressCustom.progress(70, 'Escritura subida correctamente');

        this.documentId = result.data
      },

      async fetchCompanyData() {
            const response = await this.getCompany()
            if (response.isError) {
                this.$refs.alertDismiss.showAlert(response.message, 'danger')
                return
            }

            this.originalCompany = response.data
        },
        async fetchTerritories() {
            const response = await this.getAllTerritories()
            if (response.isError) {
                this.$refs.alertDismiss.showAlert(response.error, 'danger')
            } 

            this.territories = await this.processTerritories(response.data)        
        },

        async processTerritories(data) {
            const makeOption = (x) => {
                return {value: x.id, text: x.municipality}
            }
            return data.reduce((acc, x) => {
                let { region, county, municipality } = x
                if (municipality === "ANTÁRTICA") {
                    region = "Antártica"
                    county = "Antártica"
                }
                if (municipality === "Default") {
                    return acc
                }
                
                if (region in acc) {
                    if (county in acc[region]) {
                        acc[region][county].push(makeOption(x))
                    } else {
                        acc[region][county] = [makeOption(x)]
                    }
                } else {
                    acc[region] = {[county]: [makeOption(x)]}
                }

                return acc
            }, {})
        },

        formatIsoDate(isostr) {
            const date = new Date(isostr);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        processing() {
            this.process = !this.process;
        },
        toISODate(dateString) {
            const [year, month, day] = dateString.split('-').map(Number);
            const date = new Date(year, month - 1, day);

            return date.toISOString();
        }
    },
    
    watch: {
        'company.region': {
            handler() {
                if  (!this.fetching) {
                    this.company.county = ''  
                }
            },
            deep: true
        },
        'company.county': {
            handler() {
                if (!this.fetching) {
                    this.company.idMunicipality = ''  
                }
            },
            deep: true
        },
    },
}
</script>
<style>
    
</style>
